const getTableColumnByName = (columnName, columns) =>
  columns.find(
    ({ id, accessor }) => id === columnName || accessor === columnName
  );

const getTableColumnLookup = (columns) => (columnName) =>
  getTableColumnByName(columnName, columns);

export default getTableColumnLookup;
